module.exports = "pegasus_template/assets/hexline-snapchat.png";